/* 通用 CMS 页 —— 自动目录
   从正文里的 H2 生成,标题数不够阈值就整块不显示,
   所以同一套模板挂到长条款页和三行的 Our Mission 上都不用改设置。 */
if (!customElements.get('page-content')) {
	class PageContent extends HTMLElement {
		connectedCallback() {
			if (!this.hasAttribute('data-toc')) return;

			this.body = this.querySelector('[data-page-body]');
			this.toc = this.querySelector('.bcms--toc');
			this.list = this.querySelector('.bcms--toc-list');
			if (!this.body || !this.toc || !this.list) return;

			/* 正文自带小节导航的页面(保修条款页从老站搬来的按钮组)不再叠一个目录,
			   否则同一页出现两套导航。判据:正文里已有指向本页锚点的链接。 */
			const ownNav = Array.from(this.body.querySelectorAll('a[href^="#"]')).some(
				(a) => a.getAttribute('href').length > 1
			);
			if (ownNav) return;

			const min = parseInt(this.getAttribute('data-toc-min'), 10) || 3;
			/* 包在 <a> 里的标题是导航卡片的标题(Barska Support 的 6 个磁贴),不是小节标题 ——
			   算进目录就会和卡片网格重复列一遍。 */
			const headings = Array.from(this.body.querySelectorAll('h2')).filter(
				(h) => h.textContent.trim().length > 0 && !h.closest('a')
			);
			if (headings.length < min) return;

			this.links = headings.map((h, i) => {
				if (!h.id) h.id = this.slugify(h.textContent) || 'section-' + (i + 1);
				const li = document.createElement('li');
				const a = document.createElement('a');
				a.href = '#' + h.id;
				a.textContent = h.textContent.trim();
				li.appendChild(a);
				this.list.appendChild(li);
				return a;
			});

			this.toc.hidden = false;
			this.observe(headings);
		}

		slugify(text) {
			return text
				.trim()
				.toLowerCase()
				.replace(/[^a-z0-9]+/g, '-')
				.replace(/^-+|-+$/g, '')
				.slice(0, 60);
		}

		/* 高亮当前小节。用 IntersectionObserver 而不是 scroll 事件,
		   长条款页(terms-and-conditions 50KB+)上滚动才不掉帧。 */
		observe(headings) {
			if (!('IntersectionObserver' in window)) return;

			const seen = new Map();
			const io = new IntersectionObserver(
				(entries) => {
					entries.forEach((e) => seen.set(e.target, e.isIntersecting));
					const active = headings.filter((h) => seen.get(h));
					const current = active.length
						? active[0]
						: headings
								.filter((h) => h.getBoundingClientRect().top < 120)
								.pop();
					this.links.forEach((a) =>
						a.classList.toggle(
							'is-current',
							!!current && a.getAttribute('href') === '#' + current.id
						)
					);
				},
				{ rootMargin: '-100px 0px -70% 0px', threshold: 0 }
			);

			headings.forEach((h) => io.observe(h));
		}
	}

	customElements.define('page-content', PageContent);
}
